import { TransformFnParams } from 'class-transformer';

export const phoneNumberTransformer = (params: TransformFnParams) => {
  const value = params.value;

  if (typeof value !== 'string' || !value) {
    return value;
  }

  return value.replace(/[^\d\+]+/g, '');
};
